export const useListingLoading = () => {
  // Global reactive state (shared across all components)
  const isLoading = useState<boolean>('isLoading', () => false);

  const setLoading = (value: boolean) => {
    isLoading.value = value;
  };

  return {
    isLoading,
    setLoading,
  };
};
